import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext"; // Import AuthProvider
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Orders from "./pages/Order";
import Logins from "./pages/Logins";
import Checkout from "./pages/Checkout";
import Daysale from "./pages/Daysale";
import Company from "./pages/Company";
import PaymentModes from "./pages/PaymentModes";
import Accounts from "./pages/Accounts";
import Groups from "./pages/Groups";
import Items from "./pages/Items";
import Products from "./pages/Products";
import Tables from "./pages/Tables";
import Kots from "./pages/Kots";
import KotsByKitchen from "./pages/KotsByKitchen";
import OrderBySelf from "./pages/OrderBySelf";
import SelfOrderByTable from "./pages/SelfOrderByTable";
import SelfOrderByOtp from "./pages/SelfOrderByOtp";
import TrackMyKots from "./pages/TrackMyKots";
import KotsDashboard from "./pages/KotsDashboard";
import Branches from "./pages/Branches";
import BillPrint from "./pages/BillPrint";
import Origins from "./pages/Origins";
import DayKots from "./pages/DayKots";
import Sales from "./pages/Sales";
import Payments from "./pages/Payments";
import Receipt from "./pages/Receipt";
import ProtectedRoute from "./components/ProtectedRoute"; // Import ProtectedRoute

function App() {
  return (
    // Wrap the app with AuthProvider so the authentication state is available globally
    <AuthProvider>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="login" element={<Login />} />
		<Route path="order-self/:branch/:tableName" element={<OrderBySelf />} />
		<Route path="self-order-by-table/:branch" element={<SelfOrderByTable />} />
		<Route path="self-order-by-otp" element={<SelfOrderByOtp />} />
		<Route path="track-my-kots/:branch/:tableName" element={<TrackMyKots />} />
		<Route path="kots-dashboard/:branch" element={<KotsDashboard />} />
		<Route path="bill-print/:transaction_number" element={<BillPrint />} />
		<Route path="/receipt/:transaction_number" element={<Receipt />} />

        {/* Protected Route */}
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /> </ProtectedRoute>} />
        <Route path="/logins" element={<ProtectedRoute><Logins /></ProtectedRoute>} />
        <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
        <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
        <Route path="/daysale" element={<ProtectedRoute><Daysale /></ProtectedRoute>} />
        <Route path="/company" element={<ProtectedRoute><Company /></ProtectedRoute>} />
		<Route path="/payment-modes" element={<ProtectedRoute><PaymentModes /></ProtectedRoute>} />
		<Route path="/accounts" element={<ProtectedRoute><Accounts /></ProtectedRoute>} />
		<Route path="/groups" element={<ProtectedRoute><Groups /></ProtectedRoute>} />
		<Route path="/items" element={<ProtectedRoute><Items /></ProtectedRoute>} />
		<Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
		<Route path="/tables" element={<ProtectedRoute><Tables /></ProtectedRoute>} />
		<Route path="/kots" element={<ProtectedRoute><Kots /></ProtectedRoute>} />
		<Route path="/sales" element={<ProtectedRoute><Sales /></ProtectedRoute>} />
		<Route path="/kots-by-kitchen" element={<ProtectedRoute><KotsByKitchen /></ProtectedRoute>} />
		<Route path="/branches" element={<ProtectedRoute><Branches /></ProtectedRoute>} />
		<Route path="/origins" element={<ProtectedRoute><Origins /></ProtectedRoute>} />
		<Route path="/daykots" element={<ProtectedRoute><DayKots /></ProtectedRoute>} />
		<Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
